<template>
  <div v-if="crewMember" class="flex flex-col gap-3">
    <div class="bg-white rounded-lg border">
      <Accordion
        id="tech-timeline"
        accordion-type="flush"
        :items="[{ open: false }]"
        @expanded="toggleShowBadge"
      >
        <template #content-0-header>
          <div
            class="text-sm flex flex-col gap-4 md:gap-0 md:flex-row-reverse md:justify-between md:items-center w-full"
          >
            <div>
              <TimeBadge
                v-if="showBadge"
                :label="timeBadge.label"
                :time="timeBadge.time"
                :text-only="timeBadge.textOnly || timeBadge.time === '--'"
                :background-color="timeBadge.backgroundColor"
              >
                <template #icon
                  ><component :is="timeBadge.icon"></component
                ></template>
              </TimeBadge>
            </div>
            <CrewMemberDisplay :crew-member="crewMember" />
          </div>
        </template>
        <template #content-0-body>
          <AppointmentTimeline :appointment="times" />
        </template>
      </Accordion>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";

import Accordion from "@/components/Seranova/Accordion/Accordion.vue";
import TimeBadge from "@/components/Seranova/TimeBadge/TimeBadge.vue";
import { useAppointmentTimes } from "@/AppointmentDetails/useAppointmentTimes";
import { AppointmentV2 } from "@/typings/appointment";
import AppointmentTimeline from "./AppointmentTimeline.vue";
import CrewMemberDisplay from "./CrewMemberDisplay.vue";

interface CrewMember {
  full_name: string;
}
const props = defineProps<{
  crewMember: CrewMember;
  appointment: AppointmentV2;
}>();
const showBadge = ref(true);

const times = computed(() => {
  return {
    ...props.appointment,
    ...props.crewMember
  };
});
const effectiveProps = reactive({ appointment: times });
const { timeBadge } = useAppointmentTimes(effectiveProps);

const toggleShowBadge = () => {
  showBadge.value = !showBadge.value;
};
</script>

<style scoped></style>
